// var DEV_URL = '/api/v1/';
var DEV_URL = 'https://www.lyswb.cn/api/v1/';

export { DEV_URL };
